import { css } from "@emotion/react"
import { useState } from "react"
import { Button, Collapse } from "react-bootstrap"

export default function FAQItem(props: any) {
  const [state, setState] = useState({ open: false })
  const text = props.item.acceptedAnswer ? props.item.acceptedAnswer.text : props.item.answer

  return (
    <div className="my-3 questuonItem" css={box} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
      <Button onClick={() => setState({ open: !state.open })} variant="link" className={!state.open ? "not-collapsed" : ""}>
        <span itemProp="name">{props.item.name}</span>
      </Button>
      <Collapse in={state.open} className="pb-3">
        <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <div
            itemProp="text"
            className="answer text"
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        </div>
      </Collapse>
    </div>
  )
}

const box = css`
  background-color: #e3e5e8;
  border-radius: 15px;
  .btn {
    position: relative;
    width: 100%;
    padding: 1rem;
    color: #000;
    font-weight: bold;
    text-align: left;
    background-color: transparent;
    border: none;

    &:focus {
      box-shadow: none;
    }

    span {
      padding-right: 1.5rem;
    }

    &::after {
      position: absolute;
      top: 50%;
      right: 1.25rem;
      display: block;
      width: 10px;
      height: 10px;
      margin-top: -6px;
      border: 1px solid #000;
      border-top: 0;
      border-right: 0;
      transform: rotate(135deg);
      transition: 0.35s all cubic-bezier(0.175, 0.885, 0.32, 1.275);
      content: " ";
    }
  }

  .btn.not-collapsed::after {
    transform: rotate(-45deg);
  }

  .answer {
    padding: 0.1rem 1rem;
  }

  .btn span,
  .answer {
    display: inline-block;
  }
  .answer {
    max-width: 720px;
  }
`
